/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';


import 'assets/globalStyles.css';
import 'assets/calendar.css';
import 'react-calendar/dist/Calendar.css';

import { useTranslation } from 'react-i18next';
import { Dashboard } from 'features/Dashboard/Loadable';
import { Authentication } from 'features/Authentication/Loadable';
import SessionHandoff from 'features/Authentication/SessionHandoff';
import { Subscription } from 'features/Subscription/Loadable';
import { NotFoundPage } from './pages/NotFoundPage';
import { InternalServerErrorPage } from './pages/InternalServerErrorPage';
import MaintenancePage from './pages/MaintenancePage';
import AuthContextProvider from './context/AuthContext/AuthContextProvider';
import { RootState } from 'controller/types';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthenticationSlice } from 'features/Authentication/slice';
import { HistoryComponent } from './utils/history/HistoryComponent';
import { JWTPayload } from 'features/Authentication/slice/types';
import { ForgotPassword } from 'features/ForgotPassword/Loadable';
import { ResetPassword } from 'features/ForgotPassword/components/ResetPassword/Loadable';
import { SelectRolePage } from 'core/pages/SelectRolePage/Loadable';
import { BranchSetup } from 'features/BranchSetup/Loadable';
import { UserSetup } from 'features/UserSetup/Loadable';
import { ClassSetup } from 'features/ClassSetup/Loadable';
import { ExamSetup } from 'features/ExamSetup/Loadable';
import { FeeSetup } from 'features/FeeSetup/Loadable';
import { CommunicationSetup } from 'features/CommunicationSetup/Loadable';
import { TransportSetup } from 'features/TransportSetup/Loadable';
import LeftKeyContextProvider from './context/LeftToolBarKeyContext/LeftToolbarKeyContextProvider';
import { AcademicYear } from './utils/types/modules/org';
import httpclient from 'libs/Axios';
import { SupportTicket } from 'features/SupportTicket/Loadable';
import { resetLocalStorage } from 'features/Authentication/slice/saga';
import { ParentSummary } from 'features/UserSetup/components/DesktopComponents/ParentSummary/Loadable';
import { StudentSummary } from 'features/UserSetup/components/DesktopComponents/StudentSummary/Loadable';
import { StaffSummary } from 'features/UserSetup/components/DesktopComponents/StaffSummary/Loadable';
import { UserProfileSettings } from 'features/UserSetup/components/DesktopComponents/UserProfileSettings';
import { HallticketGenerator } from 'features/ExamSetup/components/DesktopComponents/Hallticket';
import { ReportGenerator } from 'features/ExamSetup/components/DesktopComponents/Report/Loadable';
import { CumulativeReportGenerator } from 'features/ExamSetup/components/DesktopComponents/CumulativeReport/Loadable';
import { ClassSummary } from 'features/UserSetup/components/DesktopComponents/ClassSummary/Loadable';
import { ReportCardPreview } from 'features/ExamSetup/components/DesktopComponents/ReportCardPreviw/Loadable';
import { HallticketPreview } from 'features/ExamSetup/components/DesktopComponents/HallticketPreviw/Loadable';
import { BonafiedCertificate } from 'features/BranchSetup/components/DesktopComponents/Forms/BonafiedCertificate/Loadable';
import { AdmissionEnquiry as AdmissionSetup } from 'features/AdmissionEnquiry/Loadable';
import { SocialHub } from 'features/SocialHub/Loadable';
import { FeeReceipt } from 'features/FeeSetup/components/DesktopComponents/Forms/FeeReceipt/Loadable';
import { LandingPage } from 'features/LandingPage/Loadable';
import { ScheduleDemo } from './pages/ScheduleDemo/Loadable';
import History from './utils/history';
import InitialSetup from './pages/InitialSetup';
import { GoogleAuth, NewGoogleAuth } from 'features/Authentication/components/GoogleAuth/Loadable';
import { SelectInstituteWithRole } from './pages/SelectRolePage/SelectInstituteWithRole';
import { FeeReceiptTwo } from 'features/FeeSetup/components/DesktopComponents/Forms/FeeReceiptTwo/Loadable';
import { ExpenseReceiptPrint } from 'features/FeeSetup/components/DesktopComponents/Forms/ExpenseReceiptPrint/Loadable';
import { TablePrint } from './components/TablePrint';
import moment from 'moment';
import * as momentTZ from 'moment-timezone';
import { DateErrorPage } from './pages/DateErrorPage';
import { GlobalRefProvider } from 'core/components/GlobalRef';
import { MetaAuth } from 'features/Authentication/components/MetaAuth/Loadable';
import { useBeforeunload } from 'react-beforeunload';
import { isInProgress } from 'libs/Axios/requestProgressAbort';
import { MoreGlobalRef } from './components/GlobalRef/MoreGlobalRef';
// import ImageEditor from './ImageEditor';
import { NotificationPage } from './layouts/Header/LoadableNotificationPage';
import { NotificationDeliveryPage } from './layouts/Header/LoadableNotificationDeliveryPage';
// import NewGoogleAuth from 'features/Authentication/components/GoogleAuth/NewGoogleAuth'; // Imported with GoogleAuth
import { StudyCertificate } from 'features/BranchSetup/components/DesktopComponents/Forms/StudyCertificate/Loadable';
import { EventConfirmation } from 'features/Authentication/components/EventConfirmation/Loadable';
import { TransferCertificate } from 'features/UserSetup/components/DesktopComponents/Forms/TransferCertificate/Loadable';
import FeeDetailsView from 'features/FeeSetup/components/DesktopComponents/Forms/FeeDetails';
import { ResearchPlate } from './LoadableResearchPlate';
import { CURRENT_SERVER } from './utils/constants/ApiConstants';
import GlobalModuleSearch from './GlobalModuleSearch';
import Payment from 'features/demo/Payment';
import WhatsappCampaign from 'features/demo/WhatsappCampaign';
import IVR from 'features/demo/IVR';
import { ModalProvider } from './components/GlobalModal';
import { notificationInfo } from './components/Notify';
import { messaging, onMessage } from 'controller/firebase';
import { AppWrapper } from './layouts/AppWrapper/Loadable';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import { AgenticTasks } from 'features/AgenticTasks/Loadable';
import { UpdatedDashboard } from 'features/DigitalMarketing/pages/UpdatedDashboard';
import { AUTH_ACCESS_REFRESHED_EVENT, applyAccessDataToAuth, buildModulesFromAccess, getAuthAccessData, getFirstAccessiblePath } from './utils/accessControl';
import AdmissionsAssured from 'features/AdmissionsAssured';
import { isCounselorStaffRole } from './utils/role/index';
import { getCurrentHostContext } from './utils/hostname';

const isAdmissionsAssuredEnabled = true;

const RouteChangeListener = () => {
  const location = useLocation();
  React.useEffect(() => {
    toast.dismiss();
  }, [location.pathname]);
  return null;
};

const components = {
  Dashboard, SupportTicket, BranchSetup, UserSetup, ClassSetup, ExamSetup,
  FeeSetup, SocialHub, UserProfileSettings, HallticketGenerator, ReportGenerator,
  CumulativeReportGenerator, ReportCardPreview, HallticketPreview, TransferCertificate,
  BonafiedCertificate, StudyCertificate, CommunicationSetup, TransportSetup,
  InternalServerErrorPage, StudentSummary, ParentSummary, StaffSummary, ClassSummary,
  NotFoundPage, AdmissionSetup
};

const isLandingPage = window.location.pathname === "/";

const RESTRICT_MODULE = [
  "DashboardComponents", "InternalServerErrorPage", "StudentSummary", "StaffSummary",
  "ClassSummary", "NotFoundPage", "TransferCertificate", "StudyCertificate",
  "BonafiedCertificate", "HallticketPreview", "ReportCardPreview", "CumulativeReportGenerator",
  "ReportGenerator", "HallticketGenerator", "Masking_NOTAROUTER"
];

const DONT_SHOW_APPWRAPPER = [
  "TransferCertificate", "StudyCertificate", "BonafiedCertificate", "HallticketPreview",
  "ReportCardPreview", "CumulativeReportGenerator", "ReportGenerator", "HallticketGenerator"
];

// Helper functions
export function getDateAndTime(timeZone) {
  const now = momentTZ.tz(timeZone);
  const date = now.format('YYYY-MM-DD');
  const hours = now.format('HH');
  const minutes = now.format('MM');
  return { date, hours, minutes };
}

export const transFormModules = (payload) => {
  let modules: any = [];
  try {
    modules = (!!payload && typeof (payload) === "string" && Array.isArray(JSON.parse(payload))) ? JSON.parse(payload) : [];
  } catch (err) {
    modules = [];
  }
  const filteredFormData = modules?.filter(item => item.hasAccess);
  filteredFormData?.forEach(module => {
    if (module.subModules) {
      module.subModules = module.subModules.filter(subModule => subModule.hasAccess);
    }
  });
  if (!!filteredFormData?.length) {
    return filteredFormData;
  }
  return [];
}

export function extractSubdomainOuter(url) {
  // eslint-disable-next-line no-useless-escape
  const subdomainMatch = url?.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img);
  if (subdomainMatch && subdomainMatch?.length > 0) {
    return subdomainMatch?.[0]?.replace(/^https?:\/\//, '')?.replace('www.', '');
  } else {
    return "null";
  }
}

export function extractSubdomainInner(domain) {
  const parts = domain?.split('.');
  if (parts.length > 2) {
    return parts?.[0];
  } else {
    return null;
  }
}

export const findClassID = id => {
  if (id) {
    return `CLASS_ID=${id}`;
  } else {
    return ''
  }
};

// Route Components
const PublicRoutes = ({ isSubDomain, data }) => (
  <Routes>
    <Route index element={<LandingPage isSubDomain={isSubDomain} data={data} />} />
    {isAdmissionsAssuredEnabled && (
      <Route path="/admissions/*" element={<AdmissionsAssured />} />
    )}
    <Route path='/demo-ivr' element={<IVR />} />
    <Route path='/demo-payment' element={<Payment />} />
    <Route path='/demo-whatsapp-campaign' element={<WhatsappCampaign />} />
    {/* <Route path='/digital-marketing/*' element={<UpdatedDashboard />} /> */}
    <Route path='/schedule/demo/:id' element={<ScheduleDemo />} />
    <Route path="/login" element={<Authentication isSubDomain={isSubDomain} data={data} />} />
    {/* Where the onboarding wizard lands the user. */}
    <Route path="/session-handoff" element={<SessionHandoff />} />
    <Route path="/forgot-password/*" element={<ForgotPassword />} />
    <Route path="/reset-password/*" element={<ResetPassword />} />
    <Route path="/server-error" element={<InternalServerErrorPage />} />
    <Route path='/maintenance' element={<MaintenancePage />} />
    <Route path='/meta_auth/*' element={<MetaAuth />} />
    <Route path="/*" element={<NotFoundPage />} />
  </Routes>
);

const MultipleRoleSelectionRoutes = () => (
  <Routes>
    <Route path="/subscription" element={<Subscription />} />
    <Route path="/select-role" element={<SelectInstituteWithRole />} />
    <Route path="/*" element={<SelectInstituteWithRole />} />
  </Routes>
);

const StaffRoleSelectionRoutes = () => (
  <Routes>
    <Route path="/subscription" element={<Subscription />} />
    <Route path="/select-role" element={<SelectRolePage />} />
    <Route path="/*" element={<SelectRolePage />} />
  </Routes>
);

const InitialSetupRoutes = () => (
  <Routes>
    <Route path="/subscription" element={<Subscription />} />
    <Route path='/initial-setup' element={<InitialSetup />} />
    <Route path="/*" element={<Navigate to="/initial-setup" replace />} />
  </Routes>
);

const AuthenticatedRoutes = ({ modules, authData }) => {
  const firstAccessiblePath = getFirstAccessiblePath(modules, DONT_SHOW_APPWRAPPER);
  const isCounselorRole = isCounselorStaffRole(authData?.STAFF_ROLE?.STAFF_ROLE_NAME);
  const isAdmissionsCounselor = isAdmissionsAssuredEnabled && isCounselorRole;

  if (isAdmissionsCounselor) {
    return (
      <Routes>
        <Route path="/admissions/*" element={<AdmissionsAssured />} />
        <Route path="/user-roles" element={<SelectRolePage />} />
        <Route path='/meta_auth/*' element={<MetaAuth />} />
        <Route path='/maintenance' element={<MaintenancePage />} />
        <Route path="*" element={<Navigate to="/admissions" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* Routes WITHOUT AppWrapper */}
      <Route path="/fee-receipt/:id/:invoiceId/:academicYearId" element={<FeeReceipt />} />
      <Route path="/fee-receipt-view/:id/:feeID" element={<FeeReceiptTwo />} />
      <Route path="/expense-receipt-print" element={<ExpenseReceiptPrint />} />
      <Route path="/fee-details-view/:studentId/:studentClassId" element={<FeeDetailsView />} />
      <Route path="/table-print/:moduleName" element={<TablePrint />} />
      <Route path='/old_google/*' element={<GoogleAuth />} />
      <Route path='/google/*' element={<NewGoogleAuth />} />
      <Route path='/meta_auth/*' element={<MetaAuth />} />
      <Route path='/event/confirmation/:eventID/:masterEventID' element={<EventConfirmation />} />
      <Route path='/maintenance' element={<MaintenancePage />} />
      <Route path="/user-roles" element={<SelectRolePage />} />
      <Route path="/subscription" element={<Subscription />} />
      {/* <Route path="/v2" element={<DashboardV2 />} />
    <Route path="/dashboard-2" element={<Dashboard2 />} /> */}
      {["SMDEV"]?.includes(CURRENT_SERVER) && (
        <Route path='/dev-soomuch-research-playground' element={<ResearchPlate />} />
      )}

      {modules?.filter(item => DONT_SHOW_APPWRAPPER?.includes(item?.module))?.map((route: any) => {
        const Component = components[route?.module || ""];
        return (
          <Route
            key={route.module}
            path={route.path}
            element={
              <Component
                subModules={route.subModules}
                hasAccess={route.hasAccess}
                upsert={route.upsert}
                delete={route.delete}
                view={route.view}
              />
            }
          />
        );
      })}

      {/* Routes WITH AppWrapper - catch-all route */}
      {!!modules?.length && (
        <Route
          path="*"
          element={
            <AppWrapper>
              <Routes>
                {modules?.filter(item => ![...DONT_SHOW_APPWRAPPER, "Masking_NOTAROUTER"]?.includes(item?.module))?.map((route: any) => {
                  const Component = components[route?.module || ""];
                  if (!Component) return null;
                  return (
                    <Route
                      key={route.module}
                      path={route.path}
                      element={
                        <Component
                          subModules={route.subModules}
                          hasAccess={route.hasAccess}
                          upsert={route.upsert}
                          delete={route.delete}
                          view={route.view}
                        />
                      }
                    />
                  );
                })}
                {["SMDEV"]?.includes(CURRENT_SERVER) && (
                  <>
                    <Route path="/digital-marketing/*" element={<UpdatedDashboard />} />
                    <Route path='/agentic-tasks/*' element={<AgenticTasks />} />
                  </>
                )}
                <Route path='/notifications' element={<NotificationPage />} />
                <Route path='/notification-delivery' element={<NotificationDeliveryPage />} />
                <Route index element={<Navigate to={firstAccessiblePath} replace />} />
                <Route path="*" element={<Navigate to={firstAccessiblePath} replace />} />
              </Routes>
            </AppWrapper>
          }
        />
      )}
      {!modules?.length && <Route path="*" element={<NotFoundPage />} />}
    </Routes>
  );
};

export function App() {
  useBeforeunload(() => {
    if (isInProgress()) {
      return "Support Ticket Creation is in progress."
    }
    return null
  });

  const { i18n } = useTranslation();
  const { actions } = useAuthenticationSlice();
  const dispatch = useDispatch();
  const state: any = useSelector((state: RootState) => state.authentication);
  const userToken: string | null = EncryptedStorage.getItem('_UFT_');
  const dataInfo: string | null = EncryptedStorage.getItem('_DATA_');
  const TIME_ZONE_ERROR: string | null = EncryptedStorage.getItem('TIME_ZONE_ERROR');
  const hostContext = getCurrentHostContext();
  const isSubDomain = hostContext.schoolSubdomain;
  const [data, setData] = React.useState();
  const IS_LOGGED_IN = JSON.parse(dataInfo || "{}")?.IS_LOGGED_IN;
  const accessibleModules = React.useMemo(
    () => buildModulesFromAccess(state?.authData?.PERMISSION_REGISTRY, getAuthAccessData(state?.authData)),
    [state?.authData],
  );
  const isCounselorRole = isCounselorStaffRole(state?.authData?.STAFF_ROLE?.STAFF_ROLE_NAME);
  const isAdmissionsCounselor = isAdmissionsAssuredEnabled && isCounselorRole;

  React.useEffect(() => {
    if (!messaging) {
      return;
    }

    const unsubscribe = onMessage(messaging, payload => {
      const title = payload?.notification?.title || payload?.data?.title;
      const body = payload?.notification?.body || payload?.data?.MESSAGE || payload?.data?.message || payload?.data?.body;
      const actionUrl = payload?.data?.ACTION_URL || payload?.data?.action_url || payload?.data?.click_action;

      if (!title) {
        return;
      }

      const audio = new Audio('/audio/notification.wav');
      audio.play().catch(err => {
        console.warn("Notification audio play failed:", err);
      });

      notificationInfo({ title, message: body, actionUrl });
    });

    return unsubscribe;
  }, []);

  React.useEffect(() => {
    const handleAuthAccessRefreshed = (event: Event) => {
      const refreshedAuthData = (event as CustomEvent).detail;
      if (refreshedAuthData) {
        dispatch(actions.updateAuthData(refreshedAuthData));
      }
    };

    window.addEventListener(AUTH_ACCESS_REFRESHED_EVENT, handleAuthAccessRefreshed);

    return () => {
      window.removeEventListener(AUTH_ACCESS_REFRESHED_EVENT, handleAuthAccessRefreshed);
    };
  }, [actions, dispatch]);

  const isPublicPath = React.useMemo(() => {
    const publics = [
      '/', '/login', '/forgot-password', '/reset-password',
      '/demo-ivr', '/demo-payment', '/demo-whatsapp-campaign',
      ...(isAdmissionsAssuredEnabled ? ['/admissions'] : []),
      '/maintenance', '/server-error', '/meta_auth', '/schedule/demo'
    ];
    const currentPath = window.location.pathname;
    return publics.some(p => currentPath === p || currentPath.startsWith(p + '/'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Subdomain API call and Auth Guard effect
  React.useEffect(() => {
    if (!IS_LOGGED_IN && !isPublicPath) {
      History.navigate("/login");
      return;
    }

    if (isSubDomain) {
      const callAPI = async () => {
        try {
          const response = await httpclient().post("/master/Website/getContentByDomain", {
            DOMAIN_NAME: isSubDomain
          });
          if (response?.data?.data?.BranchDetails?.BRANCH_ID || response?.data?.data?.BRANCH_ID) {
            setData(response?.data?.data?.BranchDetails || response?.data?.data);
          } else {
            History.navigate("/login");
          }
        } catch (err) {
          if (!IS_LOGGED_IN && isLandingPage) {
            History.navigate("/login");
          }
        }
      };

      if (!IS_LOGGED_IN && isLandingPage) {
        callAPI();
      }
    } else {
      if (!IS_LOGGED_IN && isLandingPage) {
        History.navigate("/login");
      }
    }
  }, [IS_LOGGED_IN, isPublicPath]);

  // Window resize effect
  React.useEffect(() => {
    const handleResize = () => {
      if (IS_LOGGED_IN) {
        if (window.innerWidth !== window.outerWidth || window.innerHeight !== window.outerHeight) {
          window.location.reload();
        }
      }
    };

    if (!String(window.location.href)?.includes("branchPhoto/branchPhoto")) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (!String(window.location.href)?.includes("branchPhoto/branchPhoto")) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  // Authentication data effect
  React.useEffect(() => {
    if (userToken && dataInfo && EncryptedStorage.getItem('_DATA_')) {
      let info: JWTPayload | any = JSON.parse(dataInfo);
      try {
        const newData: JWTPayload | any = dataInfo
          ? JSON.parse(EncryptedStorage.getItem('_DATA_') as any)
          : null;
        info.IS_LOGGED_IN = true;
        if (!info?.IS_USER_INFO) {
          const fetchBranchModuleAccess = async () => {
            try {
              const [registryResponse, accessResponse] = await Promise.all([
                httpclient().get('/auth/access/registry'),
                httpclient().get('/auth/access/me'),
              ]);

              try {
                const branchRoleResponse = await httpclient().get(`/data/branchRole/list/${newData?.BRANCH_ID}`);
                info.BRANCH_ROLE_LIST = branchRoleResponse.data?.data?.BranchRoleList as any[];
              } catch (branchRoleError) {
                console.error('Unable to load branch roles:', branchRoleError);
              }

              if (newData && info.exp && Date.now() >= info.exp * 1000) {
                resetLocalStorage();
              } else {
                const resolvedInfo = applyAccessDataToAuth(
                  { ...info, ...newData },
                  registryResponse?.data?.data,
                  accessResponse?.data?.data,
                );
                dispatch(actions.loggingInSuccess(resolvedInfo));
              }
            } catch (err) {
              console.error("BRANCH ", err)
            }
          };
          const canResolveAccess = newData?.USER_ROLE_NAME !== 'STAFF' || !!newData?.STAFF_ROLE?.STAFF_ROLE_NAME;
          if (canResolveAccess && (!newData?.PERMISSION_REGISTRY?.modules?.length || !newData?.PERMISSIONS || !newData?.BRANCH_ROLE_LIST?.length)) {
            fetchBranchModuleAccess();
          }

          // Only fetched at sign-in, so a failure there leaves the setup forms
          // with empty city/language/country lists for the rest of the session.
          const fetchMasterData = async () => {
            try {
              const response = await httpclient().get('/master/prerequisites');
              const masterData = response?.data?.data || {};
              info.MASTER_DATA = masterData;
              dispatch(actions.loggingInSuccess({ ...info, ...newData, MASTER_DATA: masterData }));
              EncryptedStorage.setItem('_DATA_', JSON.stringify({ ...newData, MASTER_DATA: masterData }));
            } catch (err) {
              console.error('Unable to load master prerequisites:', err);
            }
          };
          if (newData?.BRANCH_SETUP !== 'COMPLETED' && !newData?.MASTER_DATA?.cityList?.length) {
            fetchMasterData();
          }
          const fetchBranchList = async () => {
            try {
              const response = await httpclient().get(`/data/branch/list/${newData?.INSTITUTE_ID}`);

              const data = response?.data?.data?.BranchList as any[];
              info.BRANCH_LIST = data as any[];

              if (newData && info.exp && Date.now() >= info.exp * 1000) {
                resetLocalStorage();
              } else {
                dispatch(actions.loggingInSuccess({ ...info, ...newData }));
              }
            } catch (err) {
              console.error("BRANCH ", err)
            }
          };
          if (newData?.STAFF_ROLE?.STAFF_ROLE_NAME === "SUPERADMIN") {
            if (!newData?.BRANCH_LIST?.length) {
              fetchBranchList();
            }
          }
          const fetchAcadmicYearList = async () => {
            try {
              const response = await httpclient().get(`/data/academicYear/list/${newData?.BRANCH_ID}`);
              const data = response?.data?.data?.AcademicYearList as AcademicYear[];
              const dataAt0 = data?.find(
                item => item?.ACADEMIC_YEAR_ID === newData?.CURRENT_ACADEMIC_YEAR_ID,
              );
              info.ACADEMIC_YEARS = data as AcademicYear[];
              info.SELECTED_ACADEMIC_YEAR = dataAt0 as AcademicYear;

              if (dataAt0) {
                EncryptedStorage.setItem(
                  '_SELECTED_ACADEMIC_YEAR_',
                  JSON.stringify(dataAt0),
                );
              }
            } catch (academicYearError) {
              console.error('Unable to load academic years:', academicYearError);
            }

            if (newData && info.exp && Date.now() >= info.exp * 1000) {
              resetLocalStorage();
            } else {
              dispatch(actions.loggingInSuccess({ ...info, ...newData }));
            }
          };

          const selectedAcademicYear = EncryptedStorage.getItem(
            '_SELECTED_ACADEMIC_YEAR_',
          );
          let parsedAcademicYear: any = null;
          if (selectedAcademicYear) {
            try {
              parsedAcademicYear = JSON.parse(selectedAcademicYear);
            } catch (parseError) {
              console.error('Discarding unreadable _SELECTED_ACADEMIC_YEAR_:', parseError);
              EncryptedStorage.removeItem('_SELECTED_ACADEMIC_YEAR_');
            }
          }
          if (parsedAcademicYear) {
            newData.SELECTED_ACADEMIC_YEAR = parsedAcademicYear;
          } else {
            fetchAcadmicYearList();
          }

          if (newData && info.exp && Date.now() >= info.exp * 1000) {
            resetLocalStorage();
          } else {
            dispatch(actions.loggingInSuccess({ ...info, ...newData }));
          }
        } else {
          dispatch(actions.loggingInSuccess({ ...info, ...newData }));
        }
      } catch (error: any) {
        const errorDetails = error?.response?.message || error?.message;
        console.log("errorDetails ", errorDetails)
      }
    }
  }, [userToken, dataInfo]);

  React.useEffect(() => {
    const fetchWebAppDate = async () => {
      try {
        const timeZone = state?.authData?.TIME_ZONE || 'Asia/Kolkata' /* 'America/Whitehorse' */;
        const { date, hours } = getDateAndTime(timeZone);

        // // Fetch the web application date from an external API
        // const response = await axios.get('http://worldtimeapi.org/api/timezone/Etc/UTC');
        // const webAppDate = response?.data?.datetime;

        // Get the system date
        const systemDate: string | any = moment(new Date()).format('YYYY-MM-DD');
        const hoursindian: string | any = moment(new Date()).format('HH');

        // Format the web application date
        // const formattedWebAppDate = moment(webAppDate).format('YYYY-MM-DD');

        // Compare the dates
        const isSame = ((date === systemDate) && (hours === hoursindian));

        if (!isSame) {
          EncryptedStorage.setItem("TIME_ZONE_ERROR", "YES");
          dispatch(actions.updateAuthData({ TIME_ZONE_ERROR: "YES" }))
        }
      } catch (error) {
        console.error('Error fetching the web application date:', error);
      }
    };
    if (state?.authData?.TIME_ZONE) {
      fetchWebAppDate();
    }
  }, [state?.authData?.TIME_ZONE]);

  // Route determination logic
  const getRouteComponent = () => {

    // Check for timezone error
    if (TIME_ZONE_ERROR === "YES" || state?.authData?.TIME_ZONE_ERROR === "YES") {
      return <DateErrorPage />;
    }

    // Pre-auth institute selection from /auth/login/web/institutes.
    if (
      state?.authData?.IS_INSTITUTE_SELECTION_PENDING &&
      state?.authData?.PRE_AUTH_TOKEN &&
      state?.authData?.INSTITUTES?.length
    ) {
      return <MultipleRoleSelectionRoutes />;
    }

    // Not logged in - show public routes
    if (!state?.authData?.IS_LOGGED_IN && !EncryptedStorage.getItem('_UFT_')) {
      return <PublicRoutes isSubDomain={isSubDomain} data={data} />;
    }

    // Logged in with multiple institutes or user profiles - show institute/role selection
    if (
      state?.authData?.IS_LOGGED_IN &&
      (state?.authData?.INSTITUTES?.length > 1 || state?.authData?.USER_INFO?.length > 1)
    ) {
      return <MultipleRoleSelectionRoutes />;
    }

    // Logged in as STAFF with multiple staff roles - show staff role selection
    const isStaffWithMultipleRoles = (state?.authData?.IS_LOGGED_IN &&
      ['STAFF']?.includes(state.authData?.USER_ROLE_NAME?.toUpperCase() as string) &&
      !state.authData?.STAFF_ROLE?.STAFF_ROLE_NAME &&
      state.authData?.STAFF_INFO &&
      state.authData?.STAFF_INFO.length > 1);

    if (isStaffWithMultipleRoles) {
      return <StaffRoleSelectionRoutes />;
    }

    // Logged in but branch setup not completed - show initial setup
    const needsInitialSetup =
      state?.authData?.IS_LOGGED_IN &&
      (state?.authData?.BRANCH_SETUP !== 'COMPLETED' || state?.authData?.ALLOW_INITIAL_SETUP_ACCESS);

    if (needsInitialSetup && !isAdmissionsCounselor) {
      return <InitialSetupRoutes />;
    }

    // Fully authenticated - show authenticated routes
    return <AuthenticatedRoutes modules={accessibleModules} authData={state?.authData} />;
  };

  // Only recalculate routing when auth-relevant state changes, not on every render
  // (e.g. NOTIFICATIONS updates should not trigger a full route recalculation)
  const routeComponent = React.useMemo(
    () => getRouteComponent(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      TIME_ZONE_ERROR,
      state?.authData?.TIME_ZONE_ERROR,
      state?.authData?.IS_INSTITUTE_SELECTION_PENDING,
      state?.authData?.PRE_AUTH_TOKEN,
      state?.authData?.INSTITUTES,
      state?.authData?.IS_LOGGED_IN,
      state?.authData?.USER_ROLE_NAME,
      state?.authData?.STAFF_ROLE,
      state?.authData?.STAFF_INFO,
      state?.authData?.BRANCH_SETUP,
      state?.authData?.ALLOW_INITIAL_SETUP_ACCESS,
      isAdmissionsCounselor,
      accessibleModules,
    ]
  );

  return (
    <BrowserRouter>
      <Helmet
        titleTemplate="SooMuch"
        defaultTitle="SooMuch"
        htmlAttributes={{ lang: i18n?.language || '' }}
      >
        <meta name="" content="" />
      </Helmet>

      <AuthContextProvider
        value={{
          authData: state?.authData,
          setCurrentRole: actions.selectRole,
          setAcademicYear: actions.setAcademicYear,
          setBranchID: actions.setBranchID,
        }}
      >
        <GlobalRefProvider>
          <GlobalModuleSearch arrayOfObj={isAdmissionsCounselor ? [] : accessibleModules?.filter(item => !RESTRICT_MODULE?.includes(item?.module ?? ''))} />
          <MoreGlobalRef>
            <LeftKeyContextProvider>
              <ModalProvider>
                <HistoryComponent />
                <RouteChangeListener />
                {routeComponent}
              </ModalProvider>
            </LeftKeyContextProvider>
          </MoreGlobalRef>
        </GlobalRefProvider>
      </AuthContextProvider>
    </BrowserRouter>
  );
}
